<template>
  <div class="page-loader-container" v-if="!isPageLoaded">
    <div class="page-loader">
      <div class="loading-gif">
        <img
          class="pageLoadLogo"
          src="@/assets/images/Logo_Animation.gif"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .page-loader-container{

    .page-loader{
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 99;
      background-color: rgba(3,3,3,.9);

      .loading-gif {
        .pageLoadLogo {
          display: block;
          margin: 0 auto;
          max-width: 60%;
          height: auto;
        }

        @media screen and (max-width: 1685px) {
          .pageLoadLogo {
            max-width: 65%;
          }
        }

        @media screen and (max-width: 1425px) {
          .pageLoadLogo {
            max-width: 75%;
          }
        }

        @media screen and (max-width: 1275px) {
          .pageLoadLogo {
            max-width: 85%;
          }
        }

        @media screen and (max-width: 1120) {
          .pageLoadLogo {
            max-width: 100%;
          }
        }
      }
      opacity: 0;
      -webkit-animation: fadeout 4s; /* Safari, Chrome and Opera > 12.1 */
      -moz-animation: fadeout 4s; /* Firefox < 16 */
      -ms-animation: fadeout 4s; /* Internet Explorer */
      -o-animation: fadeout 4s; /* Opera < 12.1 */
      animation: fadeout 4s;
    }

    @keyframes fadeout {
    from { opacity: 1; }
    to   { opacity: 0; }
    }
    
  }
</style>
<script>
const mockData = ['a', 'b', 'c', 'd'];
  export default {
    data: () => {
      return {
        isPageLoaded: false
      }
    },
    methods: {
      async load(){
        this.isPageLoaded = await new Promise(resolve => {
          setTimeout(() => resolve(mockData), 2000)
        })
        document.onreadystatechange = () => {
          if(document.readyState === "complete"){
            this.isPageLoaded = true;
          }
        }
      }
    },
    mounted(){
      this.load();
    }
  }
</script>
